<template>
    <b-row class="match-height">
      <b-col
lg="12"
> <b-card
      title="Receive Material Request"
    >
      <b-form
          @submit.prevent="submitEditMaterialRequest"
>
        <b-row>
          <b-col cols="12">
            <b-button
            type="button"
            variant="primary"
            class="mr-1"
            @click="previous()"
            >
            <feather-icon
                icon="ArrowLeftIcon"
                size="16"
                class="align-middle"
            />
            Back
            </b-button>
            <div class="devider" />
          <b-form-group>
            <label for="email">Number :</label>
            <input
              v-model="materialRequestNumber"
              type="text"
              name="Number"
              class="form-control"
              readonly
              >
          </b-form-group>
            <b-form-group
              label="To *"
              label-for="material_request_to"
              label-cols-md="12"
            >
              <b-form-input
                id="material_request_to"
                v-model="materialRequestTo"
                placeholder="To."
                required="required"
                readonly
              />
            </b-form-group>
            <b-form-group
              label="CC"
              label-for="material_request_cc"
              label-cols-md="12"
            >
              <b-form-input
                id="material_request_cc"
                v-model="materialRequestCc"
                placeholder="CC"
                required="required"
                readonly
              />
            </b-form-group>
            <b-form-group
              label="Reason"
              label-for="material_request_reason"
              label-cols-md="12"
            >
              <b-form-input
                id="material_request_reason"
                v-model="materialRequestReason"
                placeholder="Reason"
                required="required"
                readonly
              />
            </b-form-group>
            <b-row>
              <b-col
cols="4"
class="text-center font-weight-bold"
>
                Item name
              </b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
                Requested QTY
              </b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
                Accepted QTY
              </b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
                Sent QTY
              </b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
                Received QTY
              </b-col>
              </b-row>
             <p />
            <b-row
v-for="(chosen) in chosens"
:key="chosen.value"
>
            <br>
              <b-col
cols="4"
class="text-center"
>
                  <b-list-group>
                    <b-list-group-item href="#">
{{ chosen.label }}
</b-list-group-item>
                  </b-list-group>
                </b-col>
              <b-col
cols="2"
class="text-center"
>
              <b-form-input
                v-model="chosen.qty"
                placeholder="Qty"
                min="1"
                readonly
              />
              </b-col>
              <b-col
cols="2"
class="text-center"
>
              <b-form-input
                v-model="chosen.qty_accepted"
                placeholder="Qty Accepted"
                min="1"
                readonly
              />
              </b-col>
              <b-col
cols="2"
class="text-center"
>
              <b-form-input
                v-if="chosen.out_of_stock==false"
                v-model="chosen.qty_sent_val"
                placeholder="Qty"
                min="1"
                readonly
              />
              </b-col>
              <b-col
cols="2"
class="text-center"
>
              <b-form-input
                v-if="chosen.out_of_stock==false"
                v-model="chosen.qty_received"
                placeholder="Qty"
                min="1"
                :max="chosen.qty_sent_val"
                readonly
              />
              </b-col>
              <b-col cols="12">
                <br>
              </b-col>
              </b-row>
          </b-col>
          <!-- submit and reset -->
          <b-col offset-md="12">
            <b-button
              type="submit"
              variant="primary"
              class="mr-1"
            :disabled="submitButtonDisabled"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
      </b-col>
    </b-row>
  </template>
  <script>
  import {
    BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BListGroup, BListGroupItem, BFormCheckbox, BFormCheckboxGroup,
    } from 'bootstrap-vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import axios from 'axios'
  import moment from 'moment-timezone'
  import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import apiEndpoints from '@/constants/apiEndpoints'

  const VersionCheck = ''
  const items = []
  const chosenItem = ref(3)
  const chosens = []
  const shelves = []
  const materialRequestNumber = ''
  const materialRequestTo = ''
  const materialRequestCc = ''
  const materialRequestReason = ''
  const materialRequestQtyReceived = 0
  const materialRequestStatus = ''
  const materialRequestId = ''
  const materialRequestSent = false
  const submitButtonDisabled = false
  export default {
    components: {
      BFormCheckbox,
      BFormCheckboxGroup,
      BListGroup,
      BListGroupItem,
      BCard,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BForm,
      BButton,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        shelves,
     materialRequestId,
      VersionCheck,
      items,
      chosenItem,
      chosens,
      materialRequestNumber,
      materialRequestTo,
      materialRequestCc,
      materialRequestReason,
      materialRequestQtyReceived,
      materialRequestStatus,
      materialRequestSent,
      submitButtonDisabled,
      }
    },
    mounted() {
    const shelfsVariables = process.env.VUE_APP_SHELF_LIST.split(",")
    const shelfsRepeat = process.env.VUE_APP_SHELF_REPEAT.split(",")
    this.shelves = []
    shelfsVariables.map(s => {
      shelfsRepeat.map(r => {
        this.shelves.push(`${s}${r}`)
      })
    })
        this.getDetail()
    },
    methods: {
    getDetail() {
      const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
      const item = JSON.parse(localStorage.getItem('materialRequestReceive'))

      this.modalDetailShow = true
      this.materialRequestNumber = item.material_request_number
      this.materialRequestTo = item.material_request_to
      this.materialRequestCc = item.material_request_cc
      this.materialRequestReason = item.material_request_reason
      this.materialRequestId = item.material_request_id
      const id = item.material_request_id
      this.materialRequestId = id
      this.materialRequestSent = item.material_request_is_accepted_by_warehouse
      axios
      .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_MATERIAL_REQUEST_UNSENT}${id}`, { headers })
      .then(response => {
        if (response.data.success === true) {
        const itemsJoin = response.data.data.map(elem => (
            {
                id: elem.material_request_detail_id, label: elem.item.item_name, value: elem.material_request_detail_item_id, qty: elem.material_request_detail_item_qty_requested,qty_accepted: elem.material_request_detail_item_qty_accepted, qty_received: elem.material_request_detail_item_qty_sent,qty_sent_val: elem.material_request_detail_item_qty_sent > 0 ? elem.material_request_detail_item_qty_sent : elem.material_request_detail_item_qty_accepted, is_final: false, out_of_stock: elem.material_request_detail_is_out_of_stock === true ? true : false,
            }
        ))
        this.chosens = itemsJoin
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
        } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data failed',
                icon: 'CheckIcon',
                variant: 'danger',
              },
            })
        }
        })
    },
    submitEditMaterialRequest() {
      const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
      this.submitButtonDisabled = true
      this.materialRequestQtyReceived = 0
      this.chosens.map(elem => {
        this.materialRequestQtyReceived += parseInt(elem.qty_received)
      })
        const body = {
          material_request_id: this.materialRequestId,
          material_request_to: this.materialRequestTo,
          material_request_cc: this.materialRequestCc,
          material_request_reason: this.materialRequestReason,
          material_request_is_received: true,
          material_request_qty_received: this.materialRequestQtyReceived,
          material_request_is_accepted_by_warehouse: true,
          material_request_items: JSON.stringify(this.chosens),
          time: moment(),
        }

      axios
        .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_CONFIRM_RECEIVE_MATERIAL_REQUEST}`, body, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.chosens = []
            this.materialRequestQtyReceived = 0
            this.materialRequestReason = ""
            this.materialRequestCc = ""
            this.materialRequestTo = ""
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Update Material Request Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.replace({ name: 'apps-material-request-list' })
          } else {
            this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: 'Material Request Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        .catch(() => {
            this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: 'Material Request Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
      getOptionLabel(option) {
        return (option && option.label) || ''
      },
      putItem(val) {
        if (this.chosens.length > 0) {
              let item = null
              this.items.map(elem => {
                if (elem.value === val.value) {
                  item = {
                    label: elem.label, value: elem.value, qty: 1,
                  }
                }
              })
            this.chosens.push(item)
        } else {
              let item = null
              this.items.map(elem => {
                if (elem.value === val.value) {
                  item = {
                    label: elem.label, value: elem.value, qty: 1,
                  }
                }
            })
            this.chosens.push(item)
        }
      },
      applyItem(val) {

      },
      getOptionKey(option) {
        return (option && option.value) || ''
      },
      inputSearch(search) {

      },
      removeRow(val) {
        this.chosens = this.chosens.filter(obj => (obj.value !== val))
      },
      dateFormat(value, format = 'MM/DD/YYYY') {
          return moment.utc(value).tz('Asia/Jakarta').format(format)
      },
        previous() {
            this.$router.push({ name: 'apps-material-request-list' })
        },
    },
  }
  </script>
